import { moscowDayLabel, moscowTime } from '../../domain/moscowTime';
import type { PassDuration } from '../../domain/schedule';

export const DURATION_LABEL: Record<PassDuration, string> = { oneTime: 'Разовый', temporary: 'Временный', permanent: 'Постоянный' };

/**
 * "Разовый · сейчас · до 23:59", "Временный · сейчас · до 14.10, 23:59" — the pass window in Moscow time.
 * The end day is omitted when it is the start day; otherwise it is set off by a comma, so "14.10 до 23:59"
 * can no longer be misread as "until 23:59 today".
 */
/** pastStart: 'now' while ordering (a past start means "now"), 'since' for an existing pass. */
export function windowCaption(
  duration: PassDuration,
  startsAt: Date | null,
  expiresAt: Date | null,
  now: Date,
  pastStart: 'now' | 'since' = 'now',
): string {
  if (duration === 'permanent' || !startsAt) return 'Бессрочно';
  const from =
    pastStart === 'now' && startsAt.getTime() <= now.getTime() + 60_000 ? 'сейчас' : `${moscowDayLabel(startsAt, now)} с ${moscowTime(startsAt)}`;
  const sameDay = expiresAt && moscowDayLabel(expiresAt, startsAt) === 'сегодня';
  const to = expiresAt ? (sameDay ? `до ${moscowTime(expiresAt)}` : `до ${moscowDayLabel(expiresAt, now)}, ${moscowTime(expiresAt)}`) : '';
  return `${DURATION_LABEL[duration]} · ${from}${to ? ` · ${to}` : ''}`;
}
